import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getForwardingEmailKey, useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type {
  UseForwardingEmailDeleteParams,
  ForwardingEmailData,
} from './types';

export const useDeleteForwardingEmail: MutationFunction<
  any,
  UseForwardingEmailDeleteParams
> = ({ query, requestOptions, queryOptions } = {}) => {
  const queryClient = useQueryClient();
  const mutationKey = getForwardingEmailKey();
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ uuid }) =>
      request(`/suppliers/email_forwarding_settings/${uuid}`, {
        query,
        init: { method: 'DELETE' },
      }),
    ...queryOptions,
    mutationKey,
    onSuccess: (...args) => {
      const requestData = args[1];
      const oldData =
        queryClient.getQueryData<ForwardingEmailData[]>(mutationKey);
      queryClient.setQueryData(
        mutationKey,
        oldData
          ? oldData.filter((email) => email.uuid !== requestData.uuid)
          : [],
      );
      queryOptions?.onSuccess?.(...args);
    },
  });
};
